/* eslint-disable */
import React, { useEffect, useState } from "react";
import { Menu, Button, MenuProps, Input, Modal, Tabs, Select, message, notification, Row, Col } from 'antd';
import { useNavigate } from "react-router-dom";
import logo from './img/logo.png'
import { LogoutOutlined, UserOutlined } from "@ant-design/icons"
import { HOST, changeHostIP, APP_ACTIONS, APP_VERSION } from "../../context/appContext";
import ConnectToRemote from "../Home/modals/connect-to-remote";
import { useAppContext } from "../../context/appContext";
const Header = ({ onHeaderTabChange, hasAuth, setHasAuth, setChangeRemoteHost, setTabIndex }) => {
    // let navigate = useNavigate();
    const {
        state: { user },
        dispatch,
    } = useAppContext();
    const [selectedTab, setSelectedTab] = useState(0)
    const [displayConnectHost, setDisplayConnectHost] = useState(false);

    useEffect(() => {
        onHeaderTabChange(selectedTab);
    }, [selectedTab])

    const logout = () => {
        setHasAuth(false);
        localStorage.removeItem("jwt-token");
        localStorage.removeItem("orders");

        dispatch({
            type: APP_ACTIONS.SET_USER,
            payload: {},
        })
        setTabIndex(0);
        message.success("Logged out successfully")
    }

    const handleConnectHost = (data) => {
        if (data.host_ip === HOST) {
            message.error({ content: "already connected to this host" })
            return;
        }
        message.loading({ content: 'Waiting...', key: 'remoteHostLoading', duration: 0 });
        changeHostIP(data).then(res => {
            localStorage.setItem('remote-host', data.host_ip);
            message.destroy('remoteHostLoading');
            message.success({ content: "connected to the remote host" });
            setChangeRemoteHost(prev => !prev);


            setHasAuth(false);
            localStorage.removeItem("jwt-token");

        }).catch(err => {
            message.destroy('remoteHostLoading');
            message.error({ content: 'error, could not connect' })
        })

        setDisplayConnectHost(false);
    }


    const changeHost = () => {
        setDisplayConnectHost(true);
    }

    return (
        <>
            {displayConnectHost && <ConnectToRemote displayConnectHost={displayConnectHost} setDisplayConnectHost={setDisplayConnectHost} onConnectHost={handleConnectHost} />}

            <div style={{ height: 60, backgroundColor: "black", color: "white", padding: 5, display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                <div style={{ backgroundColor: "black", color: "white", padding: 5, display: "flex", flexDirection: "row" }}>
                    <img src={logo} width={110} height={37} alt="" style={{ cursor: "pointer" }} onClick={() => {
                        // navigate('/') 
                    }} />
                    <div style={{ color: "grey", position: "relative", top: 15, left: 5, cursor: "default", fontSize: 12, }}>Version {APP_VERSION}</div>
                    {hasAuth && <div style={{ display: "flex", flexDirection: "row", gap: 75, fontSize: 16, marginLeft: 50, position: "relative", top: 5 }}>
                        <div onClick={() => { if (selectedTab !== 0) { setSelectedTab(0) } }} style={{ cursor: "pointer", position: "relative" }}>
                            {selectedTab === 0 && <div style={{ width: "100%", height: 3, backgroundColor: "white", position: "absolute", top: -12 }} ></div>}
                            MY BOTS</div>
                        <div onClick={() => { if (selectedTab !== 1) { setSelectedTab(1) } }} style={{ cursor: "pointer", position: "relative" }}>
                            {selectedTab === 1 && <div style={{ width: "100%", height: 3, backgroundColor: "white", position: "absolute", top: -12 }} ></div>}
                            MY EXCHANGE PROFILES</div>

                        <div onClick={() => { if (selectedTab !== 3) { setSelectedTab(3) } }} style={{ cursor: "pointer", position: "relative" }}>
                            {selectedTab === 3 && <div style={{ width: "100%", height: 3, backgroundColor: "white", position: "absolute", top: -12 }} ></div>}
                            MY MARKET CONFIG</div>
                    </div>}

                </div>
                <div style={{ display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", gap: 20, marginRight: 10, }}>
                    {hasAuth && user?.is_admin &&
                        <div onClick={() => { if (selectedTab !== 2) { setSelectedTab(2) } }} style={{ display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", gap: 5, marginRight: 10, cursor: "pointer" }}>
                            <UserOutlined />
                            Control Panel
                        </div>
                    }
                    <div onClick={() => { changeHost(); }} style={{ cursor: "pointer" }}>
                        <svg style={{ position: "relative", top: 3, right: 7 }} xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 25 25">
                            <g id="Group_27" data-name="Group 27" transform="translate(-1244.741 -83)">
                                <path id="Path_5802" data-name="Path 5802" d="M278.333,189.963a3.321,3.321,0,0,0-4.7-4.7,3.288,3.288,0,0,0-.958,2.192l-7.008,4.807-5.884-5.883a1.129,1.129,0,0,0-1.552,0,13.422,13.422,0,0,0,18.982,18.981,1.1,1.1,0,0,0,0-1.551l-5.884-5.883,4.806-7.007a3.292,3.292,0,0,0,2.195-.958Zm-3.148-3.144a1.128,1.128,0,0,1,1.6,1.593,1.152,1.152,0,0,1-1.183.247c-.021-.007-.044-.013-.064-.021a1.071,1.071,0,0,1-.347-.225h0a0,0,0,0,1,0,0,1.107,1.107,0,0,1-.18-.244c-.009-.016-.018-.033-.027-.049a1.16,1.16,0,0,1-.1-.292.047.047,0,0,0,0-.008,1.086,1.086,0,0,1-.019-.2,1.123,1.123,0,0,1,.329-.8ZM267.726,207.1a11.229,11.229,0,0,1-8.679-18.352l5.715,5.713,0,0,1.041,1.04,9.048,9.048a11.153,11.153,0,0,1-7.127,2.548Zm2.028-10.75-2.506-2.505,6.111-4.192a3.345,3.345,0,0,0,.587.586Z" transform="translate(990.438 -101.294)" fill="#fff" />
                            </g>
                        </svg>
                        Host: {HOST}</div>
                    {hasAuth && <div onClick={() => { logout(); }} style={{ display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", gap: 5, marginRight: 10, cursor: "pointer" }}>
                        {/* <div style={{ borderRadius: 100, width: 25, height: 25, backgroundColor: "#d4d4d4", color: "black", textAlign: "center", }}>
                        <span style={{ position: "relative", top: 2 }}>A</span>
                    </div> */}
                        <LogoutOutlined />
                        Log out
                    </div>}
                </div>


            </div>
        </>
    );
};

export default Header;